const transformer = response => {
  const { body } = response.data;
  const json = JSON.parse(body);
  return json.EmbedUrl;
};

export default transformer;
